import SupervisorList from './views/SupervisorList.vue';
import SupervisorEdit from './views/SupervisorEdit.vue';
import Supervisor from './Root.vue';

export default {
  path: 'supervisores/',
  component: Supervisor,
  name: 'admin-Supervisor',
  redirect: '/supervisores/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-supervisor-list',
      component: SupervisorList,
    },
    {
      path: ':id',
      name: 'admin-supervisor-edit',
      component: SupervisorEdit,
    },
  ],
};
